$(document).ready ->

  if $('.flash_alert').length > 0
    alert ($($('.flash_alert')[0]).text())

  $("#exclude-from-total-score").change (event) ->
    score_selector =  $($(event.target).attr('data-score-selector'))
    if($(event.target).is(':checked'))
      score_selector.find('.size-select').css({opacity: 0.5, "pointer-events" : "none"})
    else
      score_selector.find('.size-select').css({opacity: "unset", "pointer-events" : "all"})

  $('.story-sortable').sortable({
    cursor: "move"
  });

  $('.chapter-sortable').sortable({
    cursor: "move"
  });

  $('.page-sortable').sortable({
    cursor: "move"
  });

  if $('.control-breadcrumbs').length > 0
    $('.side-menu-items-editor').click (event) ->
      confirm('Are you sure you want to leave this page without saving the changes? All unsaved data will be lost if you click \'OK\'')

  prev_language_id = $('#page_language_selection').val()
  current_language_id = $('#page_language_selection').val()

  # New pages start with no title, so their "create" button starts disabled — only the
  # currently visible language's title field counts, matching what actually gets submitted.
  update_create_button_state = ->
    submit_button = $('.require-title-page-submit')
    return if submit_button.length == 0
    title = $.trim($('.add-title:visible input').val() or '')
    submit_button.prop('disabled', title == '')

  update_create_button_state()

  $(document).on 'input', '.add-title input', ->
    update_create_button_state()

  description = ""
  explanation = ""
  correct_explanation = ""
  incorrect_explanation = ""
  info = ""
  name = ""
  placeholder_text = ""
  label_text = ""

  description_old = ""
  explanation_old = ""
  correct_explanation_old = ""
  incorrect_explanation_old = ""
  info_old = ""
  name_old = ""
  placeholder_text_old = ""
  label_text_old = ""

  $('select[id$="_page_attributes_status"]').change (event) ->
    if $(event.target).val() == "Draft"
      $('#page-language-circle').removeClass "page-language-circle-green"
      $('#page-language-circle').addClass "page-language-circle-orange"
      $('#page-status-circle').removeClass "page-status-circle-green"
      $('#page-status-circle').addClass "page-status-circle-orange"
    else
      $('#page-language-circle').removeClass "page-language-circle-orange"
      $('#page-language-circle').addClass "page-language-circle-green"
      $('#page-status-circle').removeClass "page-status-circle-orange"
      $('#page-status-circle').addClass "page-status-circle-green"
    return

  $('#page_language_selection').change (event) ->
    prev_language_id = current_language_id
    $('#page-description-' + prev_language_id).css("display", "none")
    $('#page-explanation-' + prev_language_id).css("display", "none")
    $('#page-correct-explanation-' + prev_language_id).css("display", "none")
    $('#page-incorrect-explanation-' + prev_language_id).css("display", "none")
    $('#page-info-' + prev_language_id).css("display", "none")
    $('#page-name-' + prev_language_id).css("display", "none")
    $('.page-image-' + prev_language_id).css("display", "none")
    $('.page-video-' + prev_language_id).css("display", "none")
    $('#page-embed-code-' + prev_language_id).css("display", "none")
    $('#page-placeholder-text-' + prev_language_id).css("display", "none")
    $('#page-label-text-' + prev_language_id).css("display", "none")

    for answer in $('textarea[id^="likert_scale_page_likert_scale_answers_attributes_"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      if key == prev_language_id.toString()
        $(answer).parent().css("display", "none")

    for answer in $('textarea[id^="right_order_text_page_right_order_text_answers_attributes_"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      if key == prev_language_id.toString()
        $(answer).parent().parent().css("display", "none")

    for answer in $('textarea[id^="assign_to_group_page_assign_to_group_answers_attributes_"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      if key == prev_language_id.toString()
        $(answer).parent().css("display", "none")
    $('#assign-group-a-' + prev_language_id).css("display", "none")
    $('#assign-group-b-' + prev_language_id).css("display", "none")

    for answer in $('textarea[id^="order_image_page_order_image_answers_attributes_"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      if key == prev_language_id.toString()
        $(answer).parent().css("display", "none")

    for answer in $('textarea[id^="multi_choice_page_multi_choice_answers_attributes_"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      if key == prev_language_id.toString()
        $(answer).parent().css("display", "none")

    current_language_id = $(event.target).val()
    if $('#show_description').length == 0 || $('#show_description').is(':checked')
      $('#page-description-' + current_language_id).css("display", "block")
    $('#page-explanation-' + current_language_id).css("display", "block")
    $('#page-correct-explanation-' + current_language_id).css("display", "block")
    $('#page-incorrect-explanation-' + current_language_id).css("display", "block")
    $('#page-info-' + current_language_id).css("display", "block")
    $('#page-name-' + current_language_id).css("display", "block")
    $('.page-image-' + current_language_id).css("display", "block")
    $('.page-video-' + current_language_id).css("display", "block")
    $('#page-embed-code-' + current_language_id).css("display", "block")
    $('#page-placeholder-text-' + current_language_id).css("display", "block")
    $('#page-label-text-' + current_language_id).css("display", "block")

    for answer in $('textarea[id^="likert_scale_page_likert_scale_answers_attributes_"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      if key == current_language_id.toString()
        $(answer).parent().css("display", "block")

    for answer in $('textarea[id^="right_order_text_page_right_order_text_answers_attributes_"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      if key == current_language_id.toString()
        $(answer).parent().parent().css("display", "block")

    for answer in $('textarea[id^="assign_to_group_page_assign_to_group_answers_attributes_"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      if key == current_language_id.toString()
        $(answer).parent().css("display", "block")
    $('#assign-group-a-' + current_language_id).css("display", "block")
    $('#assign-group-b-' + current_language_id).css("display", "block")

    for answer in $('textarea[id^="order_image_page_order_image_answers_attributes_"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      if key == current_language_id.toString()
        $(answer).parent().css("display", "block")

    for answer in $('textarea[id^="multi_choice_page_multi_choice_answers_attributes_"]')
      id = $(answer).attr("id")
      key = id.substring(id.lastIndexOf("_")+1)
      if key == current_language_id.toString()
        $(answer).parent().css("display", "block")

    update_create_button_state()
    return

  $('#translate-page').click (event) ->
    if confirm('Are you sure? Translating the page will result in loss of current text fields within the page you are translating to. You selected to translate all languages / one language. ')
      l_id = $('#page_language_translate_to').val()

      check = $('input[name="translate-option"]')[0].checked
      if check == true
        selection =  $($('input[name="translate-option"]')[0]).val()
      else
        selection =  $($('input[name="translate-option"]')[1]).val()

      chapter_id = $('input[id$="_page_attributes_chapter_id"]').val()

      description_old = description
      description = CKEDITOR.instances[$('#page-description-' + current_language_id).children('textarea')[0]?.id]?.getData()
      description = encodeURIComponent(description) if !!description

      explanation_old = explanation
      explanation = CKEDITOR.instances[$('#page-explanation-' + current_language_id).children('textarea')[0]?.id]?.getData()
      explanation = encodeURIComponent(explanation) if !!explanation

      correct_explanation_old = correct_explanation
      correct_explanation = CKEDITOR.instances[$('#page-correct-explanation-' + current_language_id).children('textarea')[0]?.id]?.getData()
      correct_explanation = encodeURIComponent(correct_explanation) if !!correct_explanation

      incorrect_explanation_old = incorrect_explanation
      incorrect_explanation = CKEDITOR.instances[$('#page-incorrect-explanation-' + current_language_id).children('textarea')[0]?.id]?.getData()
      incorrect_explanation = encodeURIComponent(incorrect_explanation) if !!incorrect_explanation

      info_old = info
      info = CKEDITOR.instances[$('#page-info-' + current_language_id).children('textarea')[0]?.id]?.getData()
      info = encodeURIComponent(info) if !!info

      name_old = name
      name = $('#page-name-' + current_language_id).children('input').val()

      placeholder_text_old = placeholder_text
      placeholder_text = $('#page-placeholder-text-' + current_language_id).children('textarea').val()

      label_text_old = label_text
      label_text = $('#page-label-text-' + current_language_id).children('textarea').val()

      likert_scale_answers = {}
      for answer in $('textarea[id^="likert_scale_page_likert_scale_answers_attributes_"]')
        id = $(answer).attr("id")
        sub_key = id.substring(id.lastIndexOf("attributes_")+11,id.lastIndexOf("_answer_multi"))
        key = id.substring(id.lastIndexOf("_")+1)
        val = $(answer).val()
        if key == current_language_id.toString() && val != ""
          likert_scale_answers[sub_key] = val

      ranking_answers = {}
      for answer in $('textarea[id^="right_order_text_page_right_order_text_answers_attributes_"]')
        id = $(answer).attr("id")
        sub_type = ""
        if id.indexOf("fixed_multi") != -1
          sub_key = id.substring(id.lastIndexOf("attributes_")+11,id.lastIndexOf("_fixed_multi"))
          sub_type = "fixed"
        else
          sub_key = id.substring(id.lastIndexOf("attributes_")+11,id.lastIndexOf("_draggable_multi"))
          sub_type = "draggable"
        key = id.substring(id.lastIndexOf("_")+1)
        val = $(answer).val()
        if key == current_language_id.toString() && val != ""
          if !(!!ranking_answers[sub_key])
            ranking_answers[sub_key] = {}
          ranking_answers[sub_key][sub_type] = val

      assign_answers = {}
      for answer in $('textarea[id^="assign_to_group_page_assign_to_group_answers_attributes_"]')
        id = $(answer).attr("id")
        sub_key = id.substring(id.lastIndexOf("attributes_")+11,id.lastIndexOf("_answer_multi"))
        key = id.substring(id.lastIndexOf("_")+1)
        val = $(answer).val()
        if key == current_language_id.toString() && val != ""
          assign_answers[sub_key] = val
      assign_group_a = $('#assign-group-a-' + current_language_id).children('textarea').val()
      assign_group_a = encodeURIComponent(assign_group_a) if !!assign_group_a
      assign_group_b = $('#assign-group-b-' + current_language_id).children('textarea').val()
      assign_group_b = encodeURIComponent(assign_group_b) if !!assign_group_b

      order_image_answers = {}
      for answer in $('textarea[id^="order_image_page_order_image_answers_attributes_"]')
        id = $(answer).attr("id")
        sub_key = id.substring(id.lastIndexOf("attributes_")+11,id.lastIndexOf("_answer_multi"))
        key = id.substring(id.lastIndexOf("_")+1)
        val = $(answer).val()
        if key == current_language_id.toString() && val != ""
          order_image_answers[sub_key] = val

      order_video_answers = {}
      for answer in $('textarea[id^="order_video_page_order_video_answers_attributes_"]')
        id = $(answer).attr("id")
        sub_key = id.substring(id.lastIndexOf("attributes_")+11,id.lastIndexOf("_answer_multi"))
        key = id.substring(id.lastIndexOf("_")+1)
        val = $(answer).val()
        if key == current_language_id.toString() && val != ""
          order_video_answers[sub_key] = val

      multi_text_answers = {}
      for answer in $('textarea[id^="multi_choice_page_multi_choice_answers_attributes_"]')
        id = $(answer).attr("id")
        sub_key = id.substring(id.lastIndexOf("attributes_")+11,id.lastIndexOf("_answer_multi"))
        key = id.substring(id.lastIndexOf("_")+1)
        val = $(answer).val()
        if key == current_language_id.toString() && val != ""
          multi_text_answers[sub_key] = val

      $('form').css("pointer-events", "none")
      $('form').css("opacity", "0.3")

      url = '/translate?l_id=' + l_id + "&selection=" + selection + "&chapter_id=" + chapter_id
      if !!description && description_old != description
        url += '&description=' + description
      if !!explanation && explanation_old != explanation
        url += '&explanation=' + explanation
      if !!correct_explanation && correct_explanation_old != correct_explanation
        url += '&correct_explanation=' + correct_explanation
      if !!incorrect_explanation && incorrect_explanation_old != incorrect_explanation
        url += '&incorrect_explanation=' + incorrect_explanation
      if !!info && info_old != info
        url += '&info=' + info
      if !!name && name_old != name
        url += '&name=' + name
      if !!placeholder_text && placeholder_text_old != placeholder_text
        url += '&placeholder_text=' + placeholder_text
      if !!label_text && label_text_old != label_text
        url += '&label_text=' + label_text
      if !!likert_scale_answers
        keys = Object.keys(likert_scale_answers)
        for key in keys
          answer = encodeURIComponent(likert_scale_answers[key])
          url += '&likert_scale_answers['+ key + ']=' + answer
      if !!ranking_answers
        keys = Object.keys(ranking_answers)
        for key in keys
          fixed = encodeURIComponent(ranking_answers[key]["fixed"])
          draggable = encodeURIComponent(ranking_answers[key]["draggable"])
          url += '&ranking_answers['+ key + '][fixed]=' + fixed
          url += '&ranking_answers['+ key + '][draggable]=' + draggable
      if !!assign_answers
        keys = Object.keys(assign_answers)
        for key in keys
          answer = encodeURIComponent(assign_answers[key])
          url += '&assign_answers['+ key + ']=' + answer
      if !!assign_group_a
        url += '&assign_group_a=' + assign_group_a
      if !!assign_group_b
        url += '&assign_group_b=' + assign_group_b
      if !!order_image_answers
        keys = Object.keys(order_image_answers)
        for key in keys
          answer = encodeURIComponent(order_image_answers[key])
          url += '&order_image_answers['+ key + ']=' + answer
      if !!order_video_answers
        keys = Object.keys(order_video_answers)
        for key in keys
          answer = encodeURIComponent(order_video_answers[key])
          url += '&order_video_answers['+ key + ']=' + answer
      if !!multi_text_answers
        keys = Object.keys(multi_text_answers)
        for key in keys
          answer = encodeURIComponent(multi_text_answers[key])
          url += '&multi_text_answers['+ key + ']=' + answer
      $.post(url).done((data) ->
        keys = Object.keys(data)
        for key in keys
          if key != current_language_id
            CKEDITOR.instances[$('#page-description-' + key).children('textarea')[0]?.id]?.setData(data[key]["description"]) if !!data[key]["description"]
            CKEDITOR.instances[$('#page-explanation-' + key).children('textarea')[0]?.id]?.setData(data[key]["explanation"]) if !!data[key]["explanation"]
            CKEDITOR.instances[$('#page-correct-explanation-' + key).children('textarea')[0]?.id]?.setData(data[key]["correct_explanation"]) if !!data[key]["correct_explanation"]
            CKEDITOR.instances[$('#page-incorrect-explanation-' + key).children('textarea')[0]?.id]?.setData(data[key]["incorrect_explanation"]) if !!data[key]["incorrect_explanation"]
            CKEDITOR.instances[$('#page-info-' + key).children('textarea')[0]?.id]?.setData(data[key]["info"]) if !!data[key]["info"]

            $('#page-name-' + key).children('input').val(data[key]["name"]) if !!data[key]["name"]
            $('#page-placeholder-text-' + key).children('textarea').val(data[key]["placeholder_text"]) if !!data[key]["placeholder_text"]
            $('#page-label-text-' + key).children('textarea').val(data[key]["label_text"]) if !!data[key]["label_text"]

            if !!data[key]["likert_scale_answers"]
              sub_keys = Object.keys(data[key]["likert_scale_answers"])
              for sub_key in sub_keys
                id = "likert_scale_page_likert_scale_answers_attributes_" + sub_key + "_answer_multi[" + key + "]"
                $("textarea[id='" + id + "']").val(data[key]["likert_scale_answers"][sub_key])

            if !!data[key]["ranking_answers"]
              sub_keys = Object.keys(data[key]["ranking_answers"])
              for sub_key in sub_keys
                id = "right_order_text_page_right_order_text_answers_attributes_" + sub_key + "_fixed_multi[" + key + "]"
                $("textarea[id='" + id + "']").val(data[key]["ranking_answers"][sub_key]["fixed"])
                id = "right_order_text_page_right_order_text_answers_attributes_" + sub_key + "_draggable_multi[" + key + "]"
                $("textarea[id='" + id + "']").val(data[key]["ranking_answers"][sub_key]["draggable"])

            if !!data[key]["assign_answers"]
              sub_keys = Object.keys(data[key]["assign_answers"])
              for sub_key in sub_keys
                id = "assign_to_group_page_assign_to_group_answers_attributes_" + sub_key + "_answer_multi[" + key + "]"
                $("textarea[id='" + id + "']").val(data[key]["assign_answers"][sub_key])
            $('#assign-group-a-' + key).children('textarea').val(data[key]["assign_group_a"]) if !!data[key]["assign_group_a"]
            $('#assign-group-b-' + key).children('textarea').val(data[key]["assign_group_b"]) if !!data[key]["assign_group_b"]

            if !!data[key]["order_image_answers"]
              sub_keys = Object.keys(data[key]["order_image_answers"])
              for sub_key in sub_keys
                id = "order_image_page_order_image_answers_attributes_" + sub_key + "_answer_multi[" + key + "]"
                $("textarea[id='" + id + "']").val(data[key]["order_image_answers"][sub_key])

            if !!data[key]["order_video_answers"]
              sub_keys = Object.keys(data[key]["order_video_answers"])
              for sub_key in sub_keys
                id = "order_video_page_order_video_answers_attributes_" + sub_key + "_answer_multi[" + key + "]"
                $("textarea[id='" + id + "']").val(data[key]["order_video_answers"][sub_key])

            if !!data[key]["multi_text_answers"]
              sub_keys = Object.keys(data[key]["multi_text_answers"])
              for sub_key in sub_keys
                id = "multi_choice_page_multi_choice_answers_attributes_" + sub_key + "_answer_multi[" + key + "]"
                $("textarea[id='" + id + "']").val(data[key]["multi_text_answers"][sub_key])

        $('form').css("pointer-events", "all")
        $('form').css("opacity", "1"))
    return

  $('.mandatory-answer-page-submit').on 'click', (e) ->
    if $('.mandatory-checkbox').length > 0 and $('.answer-container').length > 0 and $('.answer-container').find('.checkbox-custom').length > 0
      mandatory_correct = $('.mandatory-checkbox').get(0).checked
      single_corrent_answer_selected = false

      $('.answer-container').find('.checkbox-custom').each ->
        if $(this).get(0).checked
          single_corrent_answer_selected = true

      if !mandatory_correct or mandatory_correct and single_corrent_answer_selected
        # All is good. Do nothing.
      else
        e.preventDefault()
        alert 'Select at least one correct answer'
    return

  $('.toggle-explanation').click ->
    toggle = $(this).find('input[type=checkbox]').get(0).checked
    if toggle
      $('.neutral-container').show()
      $('.correct-incorrect-container').hide()
    else
      $('.neutral-container').hide()
      $('.correct-incorrect-container').show()

  $('#page_convert_to').change ->
    if !!$(this).val()
      $('#convert_page_link').addClass('allowed')
    else
      $('#convert_page_link').removeClass('allowed')
    return

  $("#convert_page_confirm_link").click ->
    convert_page_with_post       = $("#convert_page_confirm_link").data("convert-page-with-post") # Depends on Flipper value
    chapter_id                   = $("#convert_page_confirm_link").data("chapter-id")             # Always set
    page_id                      = $("#convert_page_confirm_link").data("page-id")                # Might be empty for new pages
    url_for_convert_page_details = "/chapters/#{chapter_id}/pages/convert_page_details.json"      # To retrieve the correct URL to post to, including the field name
    form                         = $(this).parents("form")                                        # Points to the update form
    requested_page_type          = $("#page_convert_to").val()                                    # The selected option
    action                       = form.attr("action")                                            # The current form action which we might need to override

    if convert_page_with_post
      # Get the page status. Notice we look for an ID that *contains* the text.

      page_status_dom_element = $("[id*='page_attributes_status']")
      page_status             = page_status_dom_element.val()

      # Retrieve the translation values for the name, description and info fields.
      # Notice that we look for IDs that *contain* the text.

      retrieve_translations_for = (name, dom_element_type) ->
        translations = {}

        for translation_item in $("#{dom_element_type}[id*='page_attributes_#{name}_multi']")
          translation_dom_element       = $(translation_item)
          translation_dom_id            = translation_dom_element.attr("id")
          match_result                  = translation_dom_id.match(/\[(\d+)\]/)
          continue unless match_result
          translation_key               = match_result[1]
          translation_ckeditor_instance = if dom_element_type == "input" then null else CKEDITOR.instances[translation_dom_id]
          translation_value             = if translation_ckeditor_instance then translation_ckeditor_instance.getData() else translation_dom_element.val()
          translations[translation_key] = translation_value

        translations

      name_multi        = retrieve_translations_for("name", "input")
      description_multi = retrieve_translations_for("description", "textarea")
      info_multi        = retrieve_translations_for("info", "textarea")

      # We need to retrieve the URL at which to POST the data, as well as the field name to use.

      $.ajax({
        url:      url_for_convert_page_details,
        method:   "POST",
        dataType: "json",
        data:     {
          authenticity_token:  $("meta[name='csrf-token']").attr("content"),
          requested_page_type: requested_page_type,
        }
      }).done((data) ->
        # Remember both the URL at which to post the data, as well as the field name.

        convert_page_url = data.url
        field_name       = data.field_name

        # Set the page ID (might be nil) so that in the #create action of each
        # specific page type controller, the existing page gets removed if we're
        # dealing with an existing page.

        $("#page_to_convert").val(page_id)

        # Instead of a JSON request, we need the browser
        # to always POST the form with format HTML. To do that,
        # we clone the contents of the original form, set some hidden fields,
        # remove the original form, always set the form method to POST
        # and make sure the browser submits the form automatically.

        newFormChildren = form.children().clone(true, true)

        newForm = $("<form>", {
          action: convert_page_url,
          method: "POST"
        })

        newFormChildren.appendTo(newForm)

        newForm.find("input[name='_method']").remove()

        # Set the page status

        $("<input>").attr({
            id:    "#{field_name}_page_attributes_status",
            name:  "#{field_name}[page_attributes][status]",
            type:  "hidden",
            value: page_status
        }).appendTo(newForm);

        # Set the translation values for name, description and info

        set_translations_for = (name, translations) ->
          for key, value of translations
            $("<input>").attr({
                id:    "#{field_name}_page_attributes_#{name}_multi[#{key}]",
                name:  "#{field_name}[page_attributes][#{name}_multi[#{key}]]",
                type:  "hidden",
                value: value
            }).appendTo(newForm);

        set_translations_for("name", name_multi)
        set_translations_for("description", description_multi)
        set_translations_for("info", info_multi)

        # The old form is not needed anymore.

        form.remove()

        # The new form can now be attached to the body.

        newForm.appendTo("body")
        newForm.submit()

        # To avoid flickering, we simply hide the body.

        $("body").hide()
      ).fail((error) ->
        alert("Something went wrong. Please try again.")
      )
    else
      # The flipper is disabled, so fallback to the old mechanism.

      form.submit()
